import * as React from 'react';
import { FC } from 'react';

interface ModelSchemaEvent {
  name?: string;
  startDate?: string;
  endDate?: string;
  streetAddress?: string;
  addressLocality?: string;
  postalCode?: string;
  image?: string[];
  description?: string;
  organizer?: {
    text?: string;
    url?: string;
  };
}

const SchemaEvent: FC<ModelSchemaEvent> = (props) => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
    eventStatus: 'https://schema.org/EventScheduled',
    location: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'NO',
      },
    },
    organizer: {
      '@type': 'Organization',
    },
  };

  if (props.name) {
    Object.assign(structuredData, { name: props.name });
  }

  if (props.startDate) {
    Object.assign(structuredData, { startDate: props.startDate });
  }

  if (props.endDate) {
    Object.assign(structuredData, { endDate: props.endDate });
  }

  if (props.streetAddress) {
    Object.assign(structuredData.location.address, {
      streetAddress: props.streetAddress,
    });
  }

  if (props.addressLocality) {
    Object.assign(structuredData.location.address, {
      addressLocality: props.addressLocality,
    });
  }

  if (props.postalCode) {
    Object.assign(structuredData.location.address, {
      postalCode: props.postalCode,
    });
  }

  if (props.description) {
    Object.assign(structuredData, { description: props.description });
  }

  if (props.organizer) {
    Object.assign(structuredData.organizer, { name: props.organizer.text });
    Object.assign(structuredData.organizer, { url: props.organizer.url });
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(structuredData),
      }}
    />
  );
};
export default SchemaEvent;
